import * as React from 'react';
import '../../style/modal.css';

const btnSpinner = require('../../resource/img/button-loading.gif');

interface ModalProps {
    content: JSX.Element,
    btn?: string,
    leftBtn?: string,
    rightBtn?: string,
    clickCancel: (e: React.MouseEvent<HTMLElement>) => void,
    clickConfirm?: (e: React.MouseEvent<HTMLElement>) => void,
    loading?: boolean
}

class Modal extends React.Component <ModalProps, {}> {
    public componentDidMount() {
        document.body.classList.add('cmNoScroll');
    }

    public componentWillUnmount() {
        document.body.classList.remove('cmNoScroll');
    }

    public render() {
        return (
            <div className="cmCenter modal">
                <div className="modalContainer">
                    <div className="modalContent">{this.props.content}</div>
                    {this.props.btn ?
                        <div className="cmBtnsContainer modalBtnContainer">
                            <div className="cmBtnWrapper">
                                <button type="button" className="cmBtn cmBlueBtn cmCenterBtn cmBoldText" onClick={(e) => this.props.clickCancel(e)}>
                                    {this.props.btn}
                                </button>
                            </div>
                        </div> :
                        <div className="cmBtnsContainer modalBtnContainer">
                            <div className="cmBtnWrapper">
                                <button type="button" className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickCancel(e)}
                                        disabled={this.props.loading || false}>
                                    {this.props.leftBtn}
                                </button>
                            </div>
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickConfirm(e)}
                                        disabled={this.props.loading || false}>
                                    <span className="cmBtnText">{this.props.rightBtn}</span>
                                    {this.props.loading &&
                                    <img className="cmBtnSpinner" src={btnSpinner}/>}
                                </button>
                            </div>
                        </div>}
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/Components/Modal/Modal.tsx